module.exports = __webpack_public_path__ + "img/keyboard.84ecd32d.jpg";